module.exports = __webpack_public_path__ + "static/img/top_title.3624247.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/top_title.png
// module id = sDz/
// module chunks = 1